import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetInventoryPalletGroupList($input: InventoryPalletGroupsInput!) {
    inventory {
      listPalletGroups(input: $input) {
        __typename
        ... on InventoryPalletGroupsSuccess {
          items {
            referenceNbr
            location
            totalQoh
            warehouseShelving {
              aisleCode
            }
            lots {
              rawInventoryId
              lotNbr
              batchNbr
              packageDesc
              totalPackages
              packageSize
              totalUnits
              uom
              qaStatus
              manufacturingDate
              expirationDate
              adjustmentSyncStatus
              hasProductTest
              isLocked
              isLockedByOpenGr
            }
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on InventoryPalletGroupsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
